// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__24H3M","unreadBadge":"styles_unreadBadge__2knge","modalContent":"styles_modalContent__2buKs","modal":"styles_modal__2BFeP"};